"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./config"));
__export(require("./typing"));
var utils_1 = require("./utils");
exports.generateTinestampFolder = utils_1.generateTinestampFolder;
//# sourceMappingURL=index.js.map